import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ModalRef, ModalService } from '@common/services/modal.service';

@Component({
  templateUrl: './confirmer.component.html',
  styleUrls: ['./confirmer.component.scss']
})
export class ConfirmerComponent implements OnInit {

  @Input()
  public data: { sku: string, color: string, price: number, logistics: number, profit: number }[];

  public products: { sku: string, colors: string[], price: number, logistics: number, profit: number }[]

  @Output()
  public onConfirm = new EventEmitter();

  @Output()
  public onCancel = new EventEmitter();

  constructor(private modal: ModalService) { }

  ngOnInit(): void {
    this.products = this.data.group(i => [i.sku, i.price].join('/')).map(i => ({ ...i.items[0], colors: i.items.map(x => x.color), color: undefined }));
  }

  public confirm() {
    this.modal.of(this).hide();
    this.onConfirm.emit();
  }

  public cancel() {
    this.modal.of(this).hide();
    this.onCancel.emit();
  }
}
